import { EntityMetadata } from '@ngrx/data';

/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const remindersReportEntityMetadata: EntityMetadata<any> = {
    entityName: 'RemindersReport',
    selectId: appointmentId, // .id is used if doing optimistic update
    additionalCollectionState: {
        refreshing: false
    }
    // https://stackoverflow.com/questions/62828590/how-to-extend-custom-entity-collection-reducers-in-ngrx-data

    // filterFn: nameFilter,
    // sortComparer: sortByName
    // entityDispatcherOptions: { optimisticAdd: true, optimisticUpdate: true }
};

// tslint:disable-next-line:only-arrow-functions typedef
export function appointmentId<T extends { id: any }>(appointmentid: number) {
    return  appointmentid === undefined ? undefined : appointmentid;  // .id is used if doing optimistic update
}
